import WebChat from '../../component/webchat/index';
import notification from 'c-notification';
import lang from '../../lang/index';
import loading from 'c-up-loading';
import React, {Component} from 'react';

export default class extends Component {

    static defaultProps = {
        onEnterRoomSuccess() {},
        onEnterRoomFail() {},
        onMessage() {},
        roomid: '',
        onlyView: 0
    };

    componentWillMount() {
        this.createSocket();
    }

    // 离开时关闭socket连接
    componentWillUnmount() {
        this.close();
    }

    close() {
        if (this.webchat) {
            this.webchat.destroyPingTimer();
            this.webchat.close(); // 手动断开连接不会发起重连操作
        }
    }

    send(data) {
        this.webchat.send(data);
    }

    createSocket() {
        if (!UP.Global.isLogin()){
            return;
        }

        let userToken = UP.Global.getUserToken(), 
            wType = 0,
            onlyView = this.props.onlyView,
            roomId = this.props.roomid;

        // create a webchat object
        let webchat = this.webchat = new WebChat({
            userToken: userToken,
            wType: wType,
            roomId: roomId,
            onlyView: onlyView
        });

        // listen the event 'getIntoSuccess' and you will get all the messages about the room, 
        // include websocket parameter, host uid, stream address for video and so on.
        // because the websocket has created by itself, maybe you just need some message 
        // such as uid, stream address.
        webchat.on('getIntoSuccess', (resp)=>{
            loading.hide();
            this.props.onEnterRoomSuccess(resp)
        });

        // when the request was successful, but did not return normal data.
        // then webchat will emit event 'getIntoException'.
        webchat.on('getIntoException', (code)=>{
            loading.hide();
            setTimeout(()=>{
                this.props.onEnterRoomFail(code);
            }, 100);
        });

        // the listener handler will be called when the request is timeout, which get parameter
        // to create websocket object.
        // now, you can make some notifications to let user know what happened.
        webchat.on('getIntoTimeout', ()=>{
            loading.hide();
            this.props.onEnterRoomTimeout();
        });

        // when the server is bad, webchat object will emit the event 'getIntoFail'.
        // and you need to notice user what happened as well.
        webchat.on('getIntoFail', function() {
            loading.hide();
            notification.simple(lang.template('进入房间失败'));
        });

        // 当出席失败时, 处理异常逻辑
        // 此时不能发送信息到服务端
        webchat.on('attendFail', function(code) {
            let tip = lang.template('连接失败，请退出直播间重新进入');
            notification.simple(tip);
        });

        var closeCount = 0;

        // the websocket create successful and be opening state.
        webchat.on('open', function() {
            closeCount = 0;
        });

        // listen and handle the message transfered from server
        webchat.on('message', (resp)=>{
            this.props.onMessage(resp);
        });
        
        // in the case of network dropped, the client ping request will not reach the server.
        // when the server miss the ping request twice, it will close the websocket with client,
        // the client can listen the closing state, and execute the handler you binded.
        // in general, you need to try reconnect the websocked to server. 
        // also we provide the 'webchat.reconnect' api for you. 
        webchat.on('close', function(cfg) {
            // console.log('socket closed');

            // 若手动断开，则返回
            if (this.closeByManual) {
                return;
            }
            
            // 异常状态导致连接断开，发起重连操作
            if (closeCount >= 0) {
                webchat.reinit();
                closeCount = 0;
                return;
            }
            setTimeout(function() {
                webchat.reconnect();
                closeCount++;
            }, 1500);
        });
    }

    render() {
        return null;
    }

    
};


// WEBPACK FOOTER //
// ./js/living/webchat/index.js